import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Base64 } from "js-base64";
import { getStageScreen } from "../../../../redux/navigation/navigationAction";
import { setLoading } from "../../../../redux";
import { toast } from "react-toastify";

const EsignDocument = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("data");
    const decoded = Base64.decode(token);
    const { txid, signedurl } = JSON.parse(decoded);
    console.log(decoded);
    verifyNsdlDetails(txid, signedurl);
  }, []);

  const verifyNsdlDetails = async (txid, signedurl) => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const jwtToken = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${jwtToken}`,
      },
    };
    dispatch(setLoading(true));
    const payload = { txid: txid, signedurl: signedurl };
    console.log("payload", payload);
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.submit_nsdl_details`,
        payload,
        headers
      );
      console.log("resp", resp);
      dispatch(getStageScreen());
      dispatch(setLoading(false));
      history.push("/");
    } catch (error) {
      console.error("error", error);
      dispatch(getStageScreen());
      dispatch(setLoading(false));
      history.push("/");
      toast.error("Something went wrong please try again");
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 9999,
        top: 0,
        left: 0,
        right: 0,
        height: "100%",
        background: "rgba(0,0,0,0.8)",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div style={{ height: "30%" }}></div>
      <div className="spinner-grow text-success" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      <div className="text-white">Loading...</div>
    </div>
  );
};

export default EsignDocument;
